import React from "react";
import styles from "./Footer.module.css";

import { AiOutlineCopyrightCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import aangLogo from "../../assets/images/aang_logo.png";

const Footer = () => {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: t("footer.title"),
      to: "/privacy-policy",
    },
    {
      title: t("footer.qualityPolicy"),
      to: "/quality-policy",
    },
    {
      title: t("footer.compliancePolicy"),
      to: "/compliance-policy",
    },
    {
      title: t("footer.ITServicesManagementPolicy"),
      to: "/it-services-management-policy",
    },
    {
      title: t("footer.environmentalPolicy"),
      to: "/environmental-policy",
    },
    {
      title: t("footer.healthAndSafetyPolicyAtWork"),
      to: "/health-and-safety-policy-at-work",
    },
    {
      title: t("footer.violenceAndHarassmentPolicy"),
      to: "/violence-and-harassment-policy",
    },
    {
      title: t("footer.antiBriberyPolicy"),
      to: "/anti-bribery-policy",
    },
    {
      title: t("footer.recordManagementPolicy"),
      to: "/record-management-policy",
    },
    {
      title: t("footer.businessContinuityPolicy"),
      to: "/business-continuity-policy",
    },
    {
      title: t("footer.informationSecurityPolicy"),
      to: "/information-security-policy",
    },
    {
      title: t("footer.personalDataSecurityPolicy"),
      to: "/personal-data-security-policy",
    },
    {
      title: t("footer.energyPolicy"),
      to: "/energy-policy",
    },
    {
      title: t("footer.informationSystemsAcceptableUsePolicy"),
      to: "/information-systems-acceptable-use-policy",
    },
  ];

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.policyContainer}>
        {footerLinks &&
          footerLinks.map((elem) => (
            <Link className={styles.policyLink} to={elem.to} key={elem.title}>
              {elem.title}
            </Link>
          ))}

        <a
          className={styles.policyLink}
          href="https://publicity.businessportal.gr/company/144416301000"
          target="_blank"
          rel="noreferrer"
        >
          {t("footer.gemi")}
        </a>
        <p className={styles.policyContent}>
          {/* {t("footer.description")}: */}
          <br />
          info@therecordshub.com
          <br />
          +30 2113110870
        </p>
      </div>
      <div className={styles.bottomFooter}>
        <p className={styles.copyright}>
          Copyright <AiOutlineCopyrightCircle /> 2022 therecordshub.com
        </p>
        <a
          className={styles.aangLink}
          href="https://aanggroup.com/"
          target="_blanck"
        >
          {t("footer.aang")}
          <img className={styles.aangLogo} src={aangLogo} alt="AANG group" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
